import {Action, Result} from '../types/actions';

import {ActionsHandler} from './actions_handler';
import {PipeId} from './graph';

export class NoOpActionsHandler implements ActionsHandler {
  async start(): Promise<void> {}
  async execute(pipe: unknown, actions: Action[]): Promise<Result[]> {
    return actions.map(action => {
      if (action.kind === 'load_material') {
        return {
          kind: 'load_material',
          wells: [{bay: 'unknown', well: 'unknown', volumeNl: action.volumeNl}],
        };
      } else if (action.kind === 'load_plate') {
        return {
          kind: 'load_plate',
          layouts: [{rows: 8, columns: 12}],
          maxWellVolumeNl:
            (action.capabilities.wellVolumeNl ?? 0) >= 1_500_000
              ? 2_000_000
              : 200_000,
        };
      } else if (action.kind === 'store_material') {
        return {
          kind: 'store_material',
          wells: [{bay: 'unknown', well: 'unknown', volumeNl: action.volumeNl}],
        };
      } else {
        return {kind: 'empty'};
      }
    });
  }
  async pipeFinished(_pipe: PipeId, _value: unknown): Promise<void> {}
  async finish(): Promise<void> {}
}
